export default __webpack_public_path__ + "static/media/pursuit-menu-profile-off.a02ef4c0.svg";